import React from "react";

import { chatText } from "../messages";

export function TypingIndicator({ step }) {
  return (
    <div role="status" aria-live="polite" className="flex justify-start">
      {step && (
        <div className="flex items-center gap-2 rounded-2xl rounded-bl-md border border-black/[0.03] bg-[#F5F2EB] px-4 py-2.5 text-sm text-[#0A2540]/70 shadow-sm">
          <span aria-hidden="true" className="flex gap-1">
            <span className="h-1.5 w-1.5 animate-bounce rounded-full bg-[#0A4730]/50" />
            <span className="h-1.5 w-1.5 animate-bounce rounded-full bg-[#0A4730]/50 [animation-delay:120ms]" />
            <span className="h-1.5 w-1.5 animate-bounce rounded-full bg-[#0A4730]/50 [animation-delay:240ms]" />
          </span>
          {chatText(`chat.step.${step}`)}
        </div>
      )}
    </div>
  );
}
